import React from 'react';
import cx from 'classnames';
import styles from './BillingItem.m.sass';
export var BillingItem = function BillingItem(_ref) {
  var checkout = _ref.checkout,
    selected = _ref.selected,
    disabled = _ref.disabled,
    onClick = _ref.onClick,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(checkout ? styles.rootCheckout : styles.root, selected && styles.selected, disabled && styles.disabled),
    onClick: !disabled ? onClick : undefined
  }, children);
};
export var HoverSelect = function HoverSelect(_ref2) {
  var bgColor = _ref2.bgColor,
    children = _ref2.children;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.hoverSelect, bgColor && styles[bgColor])
  }, children);
};
export var Label = function Label(_ref3) {
  var children = _ref3.children,
    checkout = _ref3.checkout;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(checkout ? styles.labelCheckout : styles.label)
  }, children);
};
export var Content = function Content(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, children);
};
export var Title = function Title(_ref5) {
  var children = _ref5.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, children);
};
export var Description = function Description(_ref6) {
  var children = _ref6.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.description
  }, children);
};
export var Actions = function Actions(_ref7) {
  var children = _ref7.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.actions
  }, children);
};
export var ItemIcon = function ItemIcon(_ref8) {
  var children = _ref8.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.itemIcon
  }, children);
};
//# sourceMappingURL=index.js.map
